'use strict';

import {fnToastrFormError, getSelectedCompanyForUser, pjaxRedirect} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnLoginToOutlay = function () {
    let elName = '.btn-login-to-outlay';

    if (!element_exists(elName)) return;

    let $el = $(elName);

    $el.off('click').on('click', function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            data: {
                company_id: getSelectedCompanyForUser(),
            },
            url: $el.data('href'),
            success: function (response) {
                if (response.url) {
                    // window.open(response.url, '_blank');
                    window.location = response.url;
                } else if (response.pjax_redirect) {
                    pjaxRedirect(response.pjax_redirect);
                }
            },
            error: fnToastrFormError
        });
    })
};